import { canv } from "@/canv/global";

type ApiBoardImageLoadResponse = {
    path: string;
};

export const ApiBoardImageLoad = (blob: Blob): Promise<ApiBoardImageLoadResponse> => {
    const data = new FormData();
    data.append("image", blob);
    data.append("token", canv.getInitDataProp("userToken"));
    data.append("boardUID", canv.getInitDataProp("boardUID"));

    const url = `${canv.host}/api/board/image/load?boardAccessToken=${canv.getInitDataProp("boardAccessToken")}`;

    return fetch(url, {
        method: "POST",
        body: data,
    }).then(async (result) => {
        const json = await result.json();
        if (!result.ok) {
            if (json?.message) {
                throw new Error(json.message);
            }
            throw new Error("Не удалось загрузить изображение, попробуйте еще раз");
        }
        return json;
    });
};
